<script>
    import { Link } from 'svelte-routing';
    import PopupNewSubscriptionButtonModal from '../components/PopupNewSubscriptionButtonModal.svelte';
    import PopupNewInviteButtonModal from '../components/PopupNewInviteButtonModal.svelte';
    export let subscriptions;

    function addNewSubscription({ id, name, feeds, dayOfWeek }) {
        subscriptions.push({ subscription: { id, name, feeds, dayOfWeek } });
    }
</script>

<PopupNewSubscriptionButtonModal addNewSubscription={addNewSubscription} />
{#if subscriptions}
    <div>
        {#each subscriptions as subscription}
        <div style="margin-bottom:20px;background-color:rgb(5,5,5);">
                <div style="display:flex;justify-content: space-between;">
                    <Link to="/s/{subscription.subscription.id}"> 
                        <div class="subscription-list-item" style="">
                            <div style="font-weight:bold;">{ subscription.subscription.name }</div>
                        </div>
                    </Link>
                    <!-- for each subscription, invite someone to subscription via phone -->
                    <div style="" class="subscription-list-item">
                        <PopupNewInviteButtonModal subscription={subscription.subscription} />
                    </div>
                </div>
            </div>
        {/each}
    </div>
{/if}

<style>
    .subscription-list-item {
        display: flex;
        /* margin-bottom: 20px; */
        padding: 30px;
        /* background: white; */
        /* background-color:rgb(5,5,5); */
        color: rgb(150,150,150);
    }
</style>